/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\AttribuedCar\AttribuedCarRow\AttribuedCarRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Wednesday October 16th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday October 16th 2024 10:13:15 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { TableCell } from "@mui/material";
import { useState } from "react";
import { AttribuedCarType } from "Types/AttribuedCar.type";
import AttribuedCarService from "Services/AttribuedCar/AttribuedCarService";
import CollapsRow from "Content/Table/CollapsRow/CollapsRow";
import OfferFiles from "Content/Cart/OfferFiles/OfferFiles";

type AttribuedCarRow = {
    data: AttribuedCarType
}

export default function AttribuedCarRow(props: AttribuedCarRow) {
    const MEC = props.data.MEC ? new Date(props.data.MEC).toLocaleDateString() : "-";
    const dateDelivery = props.data.DateDelivery ? new Date(props.data.DateDelivery).toLocaleDateString() : "-";
    const dateReport = props.data.DateReport ? new Date(props.data.DateReport).toLocaleDateString() : "-";
    const dateEndContract = props.data.DateEndContract ? new Date(props.data.DateEndContract).toLocaleDateString() : "-";
    const [open, setOpen] = useState(false);

    const handleGetFile = () => {
        return AttribuedCarService.getAttribuedCarFiles(props.data.id);
    };

    return (
        <>
            <CollapsRow collapseChildren={<OfferFiles offerID={props.data.OfferID} getter={handleGetFile} />}>
                <TableCell align="center" onClick={() => setOpen(!open)}>
                    <p className="m-0">{props.data._count.OfferFile}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{props.data.RegNb ?? "-"}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{props.data.VIN ?? "-"}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{props.data.OrderNb ?? "-"}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{MEC}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{dateDelivery}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{dateReport}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{dateEndContract}</p>
                </TableCell>
                <TableCell align="center">
                    <p className="m-0">{props.data.EndMileage ?? "-"}</p>
                </TableCell>
            </CollapsRow>
        </>
    );
};
